import { createContext, useContext, type ReactNode } from 'react';

import { unavailableMaps, type MapsPort } from './index.ts';

const MapsContext = createContext<MapsPort>(unavailableMaps);

export function MapsProvider({ maps, children }: { maps: MapsPort; children: ReactNode }) {
  return <MapsContext.Provider value={maps}>{children}</MapsContext.Provider>;
}

export function useMaps(): MapsPort {
  return useContext(MapsContext);
}
